import { createPortal } from "react-dom";

import useWhiteLabelComponent from "../../hooks/useWhiteLabelComponent";

import { isLegacyMobileApp, isMobileApp } from "../../utils/getHost";

import { ReactComponent as BackIcon } from '../../assets/images/icons/pagination-back.svg';

import { HeaderBackButton, CustomContentsContainer, HeaderText, MobileAppHeaderContainer } from "./MobileAppHeader.styles";

// Header for AppLayout on mobile app
const MobileAppHeader = ({
    layout = 'default',
    children
}) => {

    const { navColour, navTextColour, isTakeawayVendor } = useWhiteLabelComponent();

    return (
        <MobileAppHeaderContainer
            $backgroundColour={navColour}
            $textColour={navTextColour}
            $layout={layout}
            $hide={isLegacyMobileApp || isTakeawayVendor} 
        >
            { children }
        </MobileAppHeaderContainer>
    )
}

// Pages can render custom contents using this component
MobileAppHeader.CustomContents = ({
    children,
    ...props
}) => {

    const header = document.getElementsByTagName('header')[0];

    if (!isMobileApp || !header) {
        return null;
    }

    return createPortal(
        <CustomContentsContainer
            {...props}
        >
            {children}
        </CustomContentsContainer>,
        document.getElementsByTagName('header')[0]
    );
}

MobileAppHeader.BackButton = props => {
    return (
        <HeaderBackButton
            {...props}
        >
            <BackIcon />
        </HeaderBackButton>
    );
};
MobileAppHeader.Title = HeaderText;

export default MobileAppHeader;